import axios from 'axios';
import { settings } from '@/api/config';
import { getInitData } from '@/utils/getInitData';
const tg = window?.Telegram?.WebApp;

export const getSponsorsTasks = async () => {
  if (!getInitData()) {
    throw new Error('initData отсутствует');
  }
  const encodedInitData = encodeURIComponent(getInitData());
  const response = await axios.get(
    `${settings.url}api/tasks/sponsors/get?initData=${encodedInitData}`,
  );
  console.log('🚀 Sponsors tasks:', response);
  return response.data;
};

export const checkSponsorTask = async (type: string, taskId: number) => {
  if (!getInitData()) {
    throw new Error('initData отсутствует');
  }
  const encodedInitData = encodeURIComponent(getInitData());
  const response = await axios.post(
    `${settings.url}api/tasks/${type}/check/${taskId}?initData=${encodedInitData}`,
  );
  console.log('🚀 Sponsors task checked:', response);
  return response.data;
};

export const claimSponsorTask = async (taskId: number) => {
  if (!getInitData()) {
    throw new Error('initData отсутствует');
  }
  const encodedInitData = encodeURIComponent(getInitData());
  const response = await axios.post(
    `${settings.url}api/tasks/claim/${taskId}?initData=${encodedInitData}`,
  );
  console.log('🚀 Sponsors task claimed:', response);
  return response.data;
};
